import type { AdvertisingConfiguration } from '$lib/constants/advertising';

export const configuration: AdvertisingConfiguration = {
	carCard: {
		url: 'https://www.bsp-auto.com/viamichelin_fr/',
		text: 'Louer un véhicule',
		icon: {
			ariaLabel: 'go',
			name: 'rent-car',
		},
		imagesAlt: [
			{
				alt: 'voiture 1',

			},
			{
				alt: 'voiture 2',

			},
			{
				alt: 'voiture 3',

			},
		],
		trackingName: 'BSP_AUTO',
	},
	adsTextLine: {
		text: 'Location de voiture',
		ctaText: 'Ajouter',
		ctaLink: 'https://www.bsp-auto.com/viamichelin_fr/',
		color: '#FA9F54',
		trackingName: 'BSP_AUTO',
	},
};
